import { BANK_TRANSFER_NETWORK } from '~/types'
import { WithdrawLimits } from './types'

export const WITHDRAW_LIMITS: WithdrawLimits = {
  xsgd: {
    FIAT_MIN: {
      [BANK_TRANSFER_NETWORK.FAST]: 0,
      [BANK_TRANSFER_NETWORK.MEPS]: 50,
      [BANK_TRANSFER_NETWORK.SWIFT]: 100,
    },
    FIAT_MAX: {
      [BANK_TRANSFER_NETWORK.FAST]: 200 * 1000,
      [BANK_TRANSFER_NETWORK.MEPS]: 200 * 1000,
      [BANK_TRANSFER_NETWORK.SWIFT]: 200 * 1000,
    },
    STABLECOIN_MAX: 2 * 1000 * 1000,
    STABLECOIN_MIN: 10,
    STABLECOIN_UNAPPROVED_MAX: 50,
  },
  usdc: {
    FIAT_MIN: { [BANK_TRANSFER_NETWORK.SWIFT]: 100 },
    FIAT_MAX: { [BANK_TRANSFER_NETWORK.SWIFT]: Infinity },
    STABLECOIN_MAX: 2 * 1000 * 1000,
    STABLECOIN_MIN: 10,
    STABLECOIN_UNAPPROVED_MAX: 50,
  },
  usdt: {
    FIAT_MIN: { [BANK_TRANSFER_NETWORK.SWIFT]: 100 },
    FIAT_MAX: { [BANK_TRANSFER_NETWORK.SWIFT]: Infinity },
    STABLECOIN_MAX: 2 * 1000 * 1000,
    STABLECOIN_MIN: 10,
    STABLECOIN_UNAPPROVED_MAX: 50,
  },
  xusd: {
    FIAT_MIN: { [BANK_TRANSFER_NETWORK.SWIFT]: 100 },
    FIAT_MAX: { [BANK_TRANSFER_NETWORK.SWIFT]: Infinity },
    STABLECOIN_MAX: 2 * 1000 * 1000,
    STABLECOIN_MIN: 10,
    STABLECOIN_UNAPPROVED_MAX: 50,
  },
  sgd: {
    FIAT_MIN: {
      [BANK_TRANSFER_NETWORK.FAST]: 0, // we don't have min transfer out for fast network
      [BANK_TRANSFER_NETWORK.MEPS]: 50,
      [BANK_TRANSFER_NETWORK.SWIFT]: 100,
    },
    FIAT_MAX: {
      [BANK_TRANSFER_NETWORK.FAST]: 200 * 1000,
      [BANK_TRANSFER_NETWORK.MEPS]: 200 * 1000,
      [BANK_TRANSFER_NETWORK.SWIFT]: 200 * 1000,
    },
    STABLECOIN_MAX: 2 * 1000 * 1000,
    STABLECOIN_MIN: 10,
    STABLECOIN_UNAPPROVED_MAX: 50,
  },
  usd: {
    FIAT_MIN: { [BANK_TRANSFER_NETWORK.SWIFT]: 100 },
    FIAT_MAX: { [BANK_TRANSFER_NETWORK.SWIFT]: Infinity },
    STABLECOIN_MAX: 2 * 1000 * 1000,
    STABLECOIN_MIN: 10,
    STABLECOIN_UNAPPROVED_MAX: 50,
  },
}

export const FEE = {
  SGD_FIAT_DEFAULT: 0,
  USD_WITHDRAWAL_FEE_RATE: 0.002, // 0.2%
  USD_DEPOSIT_MIN_FEE: 5,
  USD_DEPOSIT_PROMOTION_FEE_RATE: 0.0005, // 0.05%
  USD_DEPOSIT_FEE_RATE: 0.001, // 0.1%
}
